import { useQuery } from '@tanstack/react-query';
import { axiosInstance } from '../../utils';
import { CardDetails } from '../../@types';


const retrieveUserPaymentMethods = async (): Promise<CardDetails[] | null> => {
  const res = await axiosInstance.get(`/api/payments/payment-methods`);
  return res.data;
};

export const useRetrieveUserPaymentMethods = () => {
  return useQuery(['retrieveUserPaymentMethods'], () => retrieveUserPaymentMethods());
};
